import React from "react";

type Props = {
  apiStatus: "delayed" | "expired" | "synced";
  optionLabel?: string;
  apiDateUpdated: Date;
};

const YachtLabel = (props: Props) => {
  return (
    <div className="my-1.5">
      {props.apiStatus === "delayed" ? (
        <span className="leading-3 rounded-[25px] py-1.5 px-3 bg-yellow-200 font-medium text-xs ">
          Temporarily missing from API
        </span>
      ) : props.apiStatus === "expired" ? (
        <span className="inline-block max-w-full rounded-[25px] py-1.5 px-3 bg-red-200 font-medium text-xs leading-4">
          {(() => {
            const d = new Date(props.apiDateUpdated);
            return isNaN(d.getTime())
              ? "Not currently in API"
              : `Missing from API since ${d.toLocaleDateString("en-GB")}`;
          })()}
        </span>
      ) : null}
      {props.optionLabel && (
        <span className="leading-3 rounded-[25px] py-1.5 px-3 bg-blue-200 font-medium text-xs ">
          {props.optionLabel}
        </span>
      )}
    </div>
  );
};

export default YachtLabel;
